var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1BD18225-4977-4D7D-9B20-849AFFED5365") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Relationship-Details",
    transform: "translate(-117.000000, -622.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(107.851460, 508.905839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.000000, 82.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-(1)",
    transform: "translate(9.208726, 31.332836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6199394,1.55365475 L12.6199394,3.02598101 C12.6194755,2.48562656 12.1815474,2.04769849 11.641193,2.0472346 L7.821558,2.0472346 C7.49774524,2.04711591 7.20273859,1.86116902 7.06295943,1.56907912 L6.53853084,0.478155479 C6.52619387,0.45156421 6.51214211,0.425802658 6.49646437,0.401033628 L11.4673183,0.401033628 C12.1038933,0.401033628 12.6199394,0.917079684 12.6199394,1.55365475 Z",
    id: "Path",
    fill: "#1058E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6199394,3.02598101 L12.6199394,9.35417948 C12.6200945,9.89501745 12.1820306,10.333709 11.641193,10.3343281 L0.978746448,10.3343281 C0.437908814,10.333709 -0.000155103687,9.89501745 0,9.35417948 L0,0.980148622 C-0.000155103687,0.439310656 0.437908814,0.000619139726 0.978746448,0 L5.77993226,0 C6.07222329,0.000134878816 6.34349875,0.151964196 6.49646437,0.401033628 C6.51214211,0.425802658 6.52619387,0.45156421 6.53853084,0.478155479 L7.06295943,1.56907912 C7.20273859,1.86116902 7.49774524,2.04711591 7.821558,2.0472346 L11.641193,2.0472346 C12.1815474,2.04769849 12.6194755,2.48562656 12.6199394,3.02598101 L12.6199394,3.02598101 Z",
    id: "Path",
    fill: "#3F8EFC"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedFolder);
export default __webpack_public_path__ + "static/media/selectedFolder.e8d54c522800957df8e0162afd63b863.svg";
export { ForwardRef as ReactComponent };